import { Component } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-lab-visits-skeleton',
  standalone: true,
  imports: [SkeletonModule],
  templateUrl: './lab-visits-skeleton.component.html',
  styleUrl: './lab-visits-skeleton.component.scss'
})
export class LabVisitsSkeletonComponent {

}
